export const blockIconsPlacesBeachAccess = (
	<span className='material-symbols-outlined'>beach_access</span>
);
